/**
 * Firebase client configuration from environment variables.
 * All keys use REACT_APP_ prefix so Create React App exposes them to the browser bundle.
 *
 * Security note: Firebase web API keys are not secret; access is enforced by
 * Firestore Security Rules + Firebase Auth (custom tokens minted by our server).
 */

const getEnv = (key, fallback = '') => process.env[key] || fallback;

export const firebaseConfig = {
  apiKey: getEnv('REACT_APP_FIREBASE_API_KEY'),
  authDomain: getEnv('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: getEnv('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getEnv('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getEnv('REACT_APP_FIREBASE_APP_ID'),
};

export const isFirebaseConfigured = () =>
  Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.authDomain &&
      firebaseConfig.projectId &&
      firebaseConfig.appId
  );

/** Default page size for paginated wishlist queries */
export const WISHLIST_PAGE_SIZE = 24;

/** localStorage keys */
export const WISHLIST_CACHE_KEY = 'wedly_wishlist_cache_v1';
export const ANONYMOUS_WISHLIST_KEY = 'wedly_anonymous_wishlist_v1';
